import { dayjs } from "~/utils/dayjs";

/**
 * Formats a date to MM/YY
 *
 * @param {*} value expressions value (result of former chain)
 */
export default (value, format) => (value ? dayjs(value, format).format("MM/YYYY") : "");
